import request from "@/utils/request.js";

/**
 * 购买课程结算页
 * @param params
 * @returns {AxiosPromise}
 */
export function buyCourseSettlement(params) {
  return request({
    url: "/tradeService/api/app/jxgl/order/buyCourseSettlement",
    method: "post",
    data: params
  });
}

/**
 * 购买课程支付
 * @param params
 * @returns {AxiosPromise}
 */
export function payCourseOrder(params) {
  return request({
    url: "/tradeService/api/app/jxgl/order/payCourseOrder",
    method: "post",
    data: params
  });
}
/**
 * 购买课程支付
 * @param params
 * @returns {AxiosPromise}
 */
export function courseOrderPay(params) {
  return request({
    url: "/tradeService/api/app/orderCommodity/courseOrderPay",
    method: "post",
    data: params
  });
}
/**
 * 查询购买结果
 * @param params
 * @returns {AxiosPromise}
 */
export function queryPayOrderResult(params) {
  return request({
    url: "/tradeService/api/app/jxgl/order/queryPayOrderResult",
    method: "post",
    data: params
  });
}
